module.exports = __webpack_public_path__ + "img/calendar-red.e3cbcca8.svg";